import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '@/api/index';
import { CLIENT_URL } from '@/constants/index';

export const viewApi = createApi({
  reducerPath: 'viewApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['View'],
  endpoints: (builder) => ({
    beautifulNumbers: builder.mutation({
      query: ({ levelId }) => ({
        url: 'beautiful-numbers',
        method: 'GET',
        params: {
          level_id: levelId,
        },
        baseURL: CLIENT_URL,
      }),
    }),
    searchContent: builder.query({
      query: ({ q, type, lang }) => ({
        url: 'search/',
        method: 'GET',
        params: {
          q,
          type,
        },
        headers: { 'Accept-Language': lang },
        baseURL: CLIENT_URL,
      }),
    }),
    tariff: builder.mutation({
      query: ({ data, lang }) => ({
        headers: { 'Accept-Language': lang },
        url: 'tariffs/choice/',
        method: 'POST',
        data,
        baseURL: CLIENT_URL,
      }),
    }),
  }),
});

export const hooks = {
  useBeautifulNumbers: viewApi.useBeautifulNumbersMutation,
  useSearchContent: viewApi.useSearchContentQuery,
  useTariff: viewApi.useTariffMutation,
};

export default viewApi;
